import api from "../../api/api";

let userPreferenceCache = null;
let userPreferenceRequest = null;
const preferenceListeners = new Set();

const unwrapPreferenceResponse = (response) => response?.data || response;

const setUserPreferenceCache = (preference) => {
  userPreferenceCache = preference;
  preferenceListeners.forEach((listener) => listener(userPreferenceCache));
  return userPreferenceCache;
};

export const getCachedUserPreference = () => userPreferenceCache;

export const subscribeUserPreferenceChange = (listener) => {
  preferenceListeners.add(listener);
  return () => {
    preferenceListeners.delete(listener);
  };
};

export const getUserPreference = ({ force = false } = {}) => {
  if (!force && userPreferenceCache) {
    return Promise.resolve(userPreferenceCache);
  }

  if (!force && userPreferenceRequest) {
    return userPreferenceRequest;
  }

  userPreferenceRequest = api
    .get("/user/preferences")
    .then((response) => {
      return setUserPreferenceCache(unwrapPreferenceResponse(response));
    })
    .finally(() => {
      userPreferenceRequest = null;
    });

  return userPreferenceRequest;
};

export const updateUserPreferenceTheme = ({ theme, value }) =>
  api
    .post(`/user/preferences/${encodeURIComponent(theme)}/update`, {
      value,
    })
    .then((response) => {
      setUserPreferenceCache(unwrapPreferenceResponse(response));
      return response;
    });

export const updatePdfPreference = ({ value }) =>
  updateUserPreferenceTheme({ theme: "pdf", value });

export const updateGeneralPreference = ({ value }) =>
  updateUserPreferenceTheme({ theme: "general", value });
